export default "__VITE_ASSET__BE_L9Q3i__"